import { reformatDate } from "./workWithDates";

export const calculateLeftDays = (date) => {
    const oneDay = 1000 * 60 * 60 * 24;

    const now = new Date();
    const upcomingDate = new Date(date);

    return Math.ceil((upcomingDate.getTime() - now.getTime()) / oneDay);
};

export const reformatFetchedTableData = (record) => {
    const { workerAnalysis } = record;

    const daysLeft = calculateLeftDays(workerAnalysis.expirationDate);

    const analyseExpiration = workerAnalysis.expirationDate
        ? `${reformatDate(workerAnalysis.expirationDate)}, ${daysLeft >= 0 ? daysLeft : 0} дн.`
        : "";

    console.log(workerAnalysis.files);
    return {
        analyse_type: {
            value: record.name,
            id: record.type_id,
        },
        analyse_status: {
            value: workerAnalysis.expired ? "Просрочен" : "Сдан",
        },
        analyse_date: {
            value: reformatDate(workerAnalysis.date),
        },
        analyse_expiration: {
            value: analyseExpiration,
        },
        files: {
            value: "0",
            items: workerAnalysis.files.map((file) => {
                let p = file.filename.split("/");
                file.origin_name = p[p.length-1];
                file.name = p[p.length-1];
                return file;

                file.filename.split("/")[1]
            }),
        },
        analyse_id: record.id,
        analysisId: workerAnalysis.id,
        comment: workerAnalysis.comment,
        expired: workerAnalysis.expired,
        expireSoon: workerAnalysis.expireSoon,
        isShowRow: true,
    };
};
